export default __webpack_public_path__ + "static/media/type_17_8.e25a9b53.svg";